<template>
  <div class="account-setting-wrapper">
    <a-modal
      wrapClassName="personal-info-modal"
      :visible="accountModalVisible"
      :closable="true"
      title="账户设置"
      @cancel="closeModal"
      :footer="null"
      :maskClosable="false"
    >
      <a-tabs :default-active-key="1">
        <a-tab-pane
          :key="tabItem.key"
          :tab="tabItem.tabName"
          v-for="tabItem in tabConfigs"
        >
          <component
            :is="tabItem.cmptFlag"
            :openSafeSetting="openSafeSetting"
            :openProjectSelection="openProjectSelection"
            @hideSafeSetting="hideSafeSetting"
            @submitSafeSetting="submitSafeSetting"
            @openModal="hideSafeSetting"
            @submitProjectSetting="submitProjectSetting"
          />
        </a-tab-pane>
      </a-tabs>
    </a-modal>
  </div>
</template>
<script>
import PersonalCenter from '../personal-center/index.vue'
import PersonalSetting from '../safe-setting/index.vue'
export default {
  props: {
    openSafeSetting: {
      type: Boolean,
      default: false
    },
    openProjectSelection: {
      type: Boolean,
      default: false
    },
  },
  components: {
    PersonalCenter,
    PersonalSetting
  },
  data () {
    return {
      accountModalVisible: true,
      tabConfigs: [
        {
          key: 1,
          tabName: '账户信息',
          cmptFlag: 'personal-center'
        },
        {
          key: 2,
          tabName: '个人设置',
          cmptFlag: 'personal-setting'
        },
      ]
    }
  },
  methods: {
    closeModal () {
      this.$emit('handleCloseModal')
    },
    hideSafeSetting (flag) {
      this.$emit('hideSafeSetting', flag)
    },
    submitSafeSetting (info) {
      this.$emit('submitSafeSetting', info)
    },
    submitProjectSetting (info) {
      this.$emit('submitProjectSetting', info)
    },

  }
}
</script>
<style lang="less" scoped>
</style>